import { render, staticRenderFns } from "./CreateOrEditSubscriptionPlan.vue?vue&type=template&id=525267fa&scoped=true"
import script from "./CreateOrEditSubscriptionPlan.vue?vue&type=script&lang=js"
export * from "./CreateOrEditSubscriptionPlan.vue?vue&type=script&lang=js"
import style0 from "./CreateOrEditSubscriptionPlan.vue?vue&type=style&index=0&id=525267fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525267fa",
  null
  
)

export default component.exports